import { render } from "./read-eprocurement.vue?vue&type=template&id=9b2138b6&scoped=true"
import script from "./read-eprocurement.vue?vue&type=script&lang=js"
export * from "./read-eprocurement.vue?vue&type=script&lang=js"

import "./read-eprocurement.vue?vue&type=style&index=0&id=9b2138b6&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b2138b6"]])

export default __exports__